// Api/config.js

/**
 * Environment validation helper
 * @param {string} envVar - Environment variable name
 * @param {string} value - Environment variable value
 */
const validateEnvVar = (envVar, value) => {
  if (!value || value === 'undefined') {
    return false;
  }
  return true;
};

// Get environment variables with validation
const username = process.env.VUE_APP_USERNAME;
const password = process.env.VUE_APP_PASSWORD;

// Validate required environment variables
const isUsernameValid = validateEnvVar('VUE_APP_USERNAME', username);
const isPasswordValid = validateEnvVar('VUE_APP_PASSWORD', password);

// Generate Basic Authentication header
const generateAuthHeader = () => {
  if (!isUsernameValid || !isPasswordValid) {
    return null;
  }
  
  try {
    const credentials = `${username}:${password}`;
    const base64Credentials = btoa(credentials);
    return `Basic ${base64Credentials}`;
  } catch (error) {
    return null;
  }
};

// Configuration object
const config = {
  // Authentication
  username,
  password,
  authHeader: generateAuthHeader(),
  
  // API endpoints
  apiUrls: {
    main: process.env.VUE_APP_URL_HTTP || 'https://www.alareeef.com/AlearifAPIs_1/APIs/',
    dsp: process.env.VUE_APP_URL_HTTPDSP || 'https://www.alareeef.com/DSPAPIs/APIs/',
  },
  
  // Request configuration
  requestConfig: {
    timeout: 30000, // 30 seconds
    retryAttempts: 3,
    retryDelay: 1000, // 1 second
  },
  
  // Feature flags
  features: {
    enableRequestLogging: process.env.NODE_ENV === 'development',
    enableRetry: true,
    enableCaching: false,
  },
  
  // Validation methods
  isValid() {
    return isUsernameValid && isPasswordValid && this.authHeader !== null;
  },
  
  getEnvironment() {
    return process.env.NODE_ENV || 'development';
  },
  
  isDevelopment() {
    return this.getEnvironment() === 'development';
  },
  
  isProduction() {
    return this.getEnvironment() === 'production';
  }
};

export default config;
